import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import * as actionTypes from '../../../store/actions';
import EquipmentJson from '../../components/Admin/EquipmentJsonSchemaDefinitionPage';
import Dashboard from '../../components/Dashboard/Dashboard';
import EquipmentPage from '../../components/Equipment';
import Breadcrumbs from './Breadcrumb';
import NavBar from './NavBar';
import Navigation from './Navigation';
import './app.scss';
import EquipmentUnitCategories from '../../components/Admin/EquipmentUnitCategory';
import Sensor from '../../components/Sensor';
import ProfileBasedSensors from '../../components/Sensor/ProfileBasedSensors';
import ProfileBasedBearingList from '../../components/Bearing/ProfileBasedBearingList';
import Login from './Login';
import { SESSION_STORAGE_AUTH_KEY } from '../../../Common/constants';
import GlobalLoginPopup from '../../../Common/GlobalLoginPopup';

const AdminLayout = (props) => {

	const location = useLocation();
	const isAuthenticated = sessionStorage.getItem(SESSION_STORAGE_AUTH_KEY);
	const [selectedCustomerDetails, setSelectedCustomerDetails] = useState({});

	const isJwtExpired = useSelector(store => store.customers?.isJwtExpired);

	useEffect(() => {
		const locationArray = location.pathname.split('/');
		if (locationArray.includes("customer") && !_.isEmpty(props.allCustomers)) {
			setSelectedCustomerDetails(props.allCustomers.filter(customer => customer.id.toString() === locationArray[2]));
		}
	}, [location, props.allCustomers]);

  const routes = [
		{
			path: "/",
			exact: true,
			Component: Dashboard,
			breadCrumbs: [
				{ name: "Home", path: "/", params: false, icon: "feather icon-home" }
			]
		},
		{
			path: "/customer/:id",
			exact: true,
			Component: Dashboard,
			breadCrumbs: [
				{ name: "Home", path: "/", params: false, icon: "feather icon-home" },
				{ name: !_.isEmpty(selectedCustomerDetails[0]) && !_.isEmpty(Object.keys(selectedCustomerDetails[0])) && selectedCustomerDetails[0].customerName, path: "/" }
			]
		},
		{
			path: "/profile/:id",
			exact: true,
			Component: EquipmentPage,
			breadCrumbs: []
		},
		{
			path: "/equipment-unit/json-schema",
			exact: true,
			Component: EquipmentJson,
			breadCrumbs: [
				{ name: "Home", path: "/", params: false, icon: "feather icon-home", displayLabel: true },
				{ name: "JSON Schema", path: "/equipment-unit/json-schema", params: true },
			]
		},
		{
			path: "/login",
			exact: true,
			Component: Login,
			breadCrumbs: []
		},
		{
			path: "/equipment-unit-categories/:id",
			exact: true,
			Component: EquipmentUnitCategories,
			breadCrumbs: []
		},
		{
			path: "/categories/global",
			exact: true,
			Component: EquipmentUnitCategories,
			breadCrumbs: [
				{ name: "Home", path: "/", params: false, icon: "feather icon-home", displayLabel: true },
				{ name: "Global Categories", path: "/sensor/json-schema", params: true },
			]
		},
		{
			path: "/sensor/all",
			exact: true,
			Component: Sensor,
			breadCrumbs: [
				{ name: "Home", path: "/", params: false, icon: "feather icon-home", displayLabel: true },
				{ name: "Sensor List", path: "/sensor/all", params: true },
			]
		},
		{
			path: "/profile/sensor/:id",
			exact: true,
			Component: ProfileBasedSensors,
			breadCrumbs: []
		},
		{
			path: "/profile/bearing/:id",
			exact: true,
			Component: ProfileBasedBearingList,
			breadCrumbs: []
		}
	];

	const mobileOutClickHandler = () => {
		if (window.innerWidth < 992 && props.collapseMenu) {
			props.onComponentWillMount();
		}
	}

	return (
		<Switch>
			{
				routes.map((element, index) => 
					<Route
						key={index}
						path={element.path}
						exact={element.exact}
						render={
							(props) => {
								const Component = element.Component

								if(element.path === "/login" || isAuthenticated !== "true") {
									return (
										<Login
											authenticateUser={
												() => {
													sessionStorage.setItem(SESSION_STORAGE_AUTH_KEY, "true");
													window.location.reload();
												}
											}
										/>
									)
								}
								else {
									return (
										<>
											<Navigation />
											<NavBar />
											<ToastContainer />
											<div className="pcoded-main-container" onClick={() => mobileOutClickHandler}>
												<div className="pcoded-wrapper">
													<div className="pcoded-content">
														<div className="pcoded-inner-content">
															<div className="main-body">
																<div className="page-wrapper">
																	<div className='d-flex m-1'>
																		<Breadcrumbs data={element} />
																	</div>
																		<Component {...props} />
																		{
																			isJwtExpired &&
																				<GlobalLoginPopup />
																		}
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</>
									)
								}
							}
						}
					/>
				)
			}
		</Switch>
	);
}
const mapStateToProps = state => {
	return {
		defaultPath: state.defaultPath,
		collapseMenu: state.collapseMenu,
		configBlock: state.configBlock,
		layout: state.layout,
		allCustomers: state.customers.customers,
		selectedCustomerDetails: state.customers.selectedCustomerDetails
	};
};

const mapDispatchToProps = dispatch => {
  return {
	onComponentWillMount: () => dispatch({ type: actionTypes.COLLAPSE_MENU })
  };
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)
	((AdminLayout))
);
